<div class="edit-profile-user">
    <div class="col-xl-12 pt-2 pb-2 dialog-header">
        <h5 class="font-weight-bold m-0 ms-1"><i class="ph ph-user me-1"></i>
            {{ 'modules.user.common.profile' | translate }}
        </h5>
        <span class="icon-close-dialog" mat-dialog-close>
            <i class="ph ph-x"></i>
        </span>
    </div>
    <div class="p-2">
        <form [formGroup]="form" enctype='multipart/form-data'>
            <div class="card box-avatar mb-1">
                <div class="text-center pb-0 position-relative">
                    <img [src]="imageSrc" alt="avatar" class="rounded-pill border " height="130" width="130">
                    <p class="text-muted mt-2 mb-1">{{ userInfo.email }}</p>
                    <span class="badge bg-success fw-normal mb-1 mt-1 me-2" *ngIf="userInfo.roleName">
                        {{ userInfo.roleName }}
                    </span>
                </div>
            </div>
            <div class="row flex-wrap">
                <div class="col-12 mb-2">
                    <span class="form-label mb-1 d-inline-block">
                        <strong>{{ 'modules.user.common.userId' | translate }}</strong>
                    </span>
                    <div class="form-control-feedback">
                        <input type="text" formControlName="id" class="form-control" readonly>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <span class="form-label mb-1 d-inline-block">
                        <strong>{{ 'modules.user.common.username' | translate }}</strong>
                    </span>
                    <div class="form-control-feedback">
                        <input type="text" formControlName="username" class="form-control" readonly>
                    </div>
                </div>
                <div class="col-12">
                    <span class="form-label mb-1 d-inline-block">
                        <strong>{{ 'modules.user.common.email' | translate }}</strong>
                    </span>
                    <div class="form-control-feedback">
                        <input type="text" formControlName="email" class="form-control" readonly>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="col-xl-12 pt-2 pb-2 dialog-footer">
        <button class="btn btn-danger" mat-dialog-close>{{ 'common.button.cancel' | translate }} <i class="ph-x ms-1"></i></button>
        <!--<button class="btn btn-success" [disabled]="form.invalid" (click)="saveUserInfo()">{{ 'common.button.update' | translate }} <i class="ph-floppy-disk ms-1"></i></button>-->
    </div>
</div>
